<script setup>
import { computed, onMounted, ref } from 'vue'
import api from '@/services/api'
import { usePrintGiftsReportsStore } from '@/stores/printGiftsReports'

const printGiftsReportsStore = usePrintGiftsReportsStore()

// Computed: formData from Pinia store
const formData = computed(() => printGiftsReportsStore.formData)

// State replacement for useAsyncState
const categories = ref([])

onMounted(async () => {
    try {
        const response = await api.get('api/component/m_products_categories', {
            params: {
                parentId: 0,
                fields: ['id', 'title'],
                sort: 'title'
            }
        })
        categories.value = response?.data?.items || []
    } catch (error) {
        console.error('Failed to fetch product categories:', error)
        categories.value = []
    }
})
</script>

<template>
    <select
        v-if="formData"
        v-model="formData.primaryCategory"
        class="form-select form-select-sm"
        name="primaryCategory"
        required
    >
        <option :value="0">- All -</option>
        <option v-for="category in categories" :key="category.id" :value="category.id">
            {{ category.title }}
        </option>
    </select>
</template>